(function () {
  'use strict';
  const boot = () => document.querySelectorAll('[data-wakey-skin]').forEach(init);
  function init(root) {
    if (root.dataset.initialized || !window.WakeySkin) return;
    root.dataset.initialized = 'true';
    const engine = window.WakeySkin;
    const data = JSON.parse(root.querySelector('[data-wakey-data]').textContent);
    data.root = data.root.endsWith('/') ? data.root : data.root + '/';
    const strings = JSON.parse(root.querySelector('[data-wakey-i18n]').textContent);
    const t = key => (strings[key] || key).replace(/&amp;/g,'&').replace(/&quot;/g,'"').replace(/&#39;|&apos;/g,"'").replace(/&lt;/g,'<').replace(/&gt;/g,'>');
    const money = cents => new Intl.NumberFormat(data.locale || 'fr-FR', {style:'currency',currency:data.currency || 'EUR'}).format(cents / 100);
    const intro = root.querySelector('[data-intro]');
    const quiz = root.querySelector('[data-quiz]');
    const result = root.querySelector('[data-result]');
    const fields = root.querySelector('[data-fields]');
    const next = root.querySelector('[data-next]');
    const previous = root.querySelector('[data-previous]');
    const progress = root.querySelector('[data-progress]');
    const count = root.querySelector('[data-count]');
    const error = root.querySelector('[data-error]');
    const answers = {};
    let index = 0;
    let mode = 'essential';
    let diagnostic;
    let routine;
    let busy = false;
    let catalog = [...new Map(data.products.filter(Boolean).map(product => [String(product.id),product])).values()];
    const definitions = [
      ['age','q_age',[['moins18','age_minor'],['18_25','age_18_25'],['26_35','age_26_35'],['36_45','age_36_45'],['46_55','age_46_55'],['plus55','age_plus55']]],
      ['environnement','q_environment',[['grande_ville','env_city'],['urbain','env_urban'],['petite_ville','env_town'],['campagne','env_country']]],
      ['type','q_type',[['seche','type_dry'],['mixte','type_combination'],['grasse','type_oily'],['normale','type_normal'],['inconnue','unknown']]],
      ['sensibilite','q_sensitivity',[['souvent','often'],['parfois','sometimes'],['jamais','rarely']]],
      ['deshydratation','q_dehydration',[['souvent','dehydration_often'],['parfois','sometimes'],['non','no']]],
      ['imperfections','q_blemishes',[['regulierement','regularly'],['occasionnellement','occasionally'],['jamais','rarely']]],
      ['teint','q_complexion',[['terne','complexion_dull'],['irregulier','complexion_uneven'],['lumineux','complexion_bright'],['inconnu','unknown']]],
      ['signes_age','q_aging',[['non','no'],['ridules','fine_lines'],['rides','wrinkles']]],
      ['priorite','q_priority',[['imperfections','need_IMP'],['hydratation','need_HYD'],['age','need_AGE'],['eclat','need_ECL'],['sensibilite','need_SEN']]],
      ['secondaires','q_secondary',[['imperfections','need_IMP'],['hydratation','need_HYD'],['age','need_AGE'],['eclat','need_ECL'],['sensibilite','need_SEN'],['aucun','none']]]
    ];
    function element(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    }
    function focus(node) {
      node.focus({preventScroll:true});
      node.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    function reveal(panel) {
      intro.hidden = panel !== intro;
      quiz.hidden = panel !== quiz;
      result.hidden = panel !== result;
    }
    function valid() {
      const value = answers[definitions[index][0]];
      return Array.isArray(value) ? value.length > 0 : Boolean(value);
    }
    function question() {
      const [key,title,choices] = definitions[index];
      fields.replaceChildren();
      count.textContent = t('question_count').replace('{current}', index + 1).replace('{total}', definitions.length);
      progress.value = index;
      progress.setAttribute('aria-label', count.textContent);
      previous.hidden = index === 0;
      next.textContent = t(index === definitions.length - 1 ? 'show_result' : 'next');
      const fieldset = element('fieldset','wk-fieldset');
      const legend = element('legend','wk-question',t(title));
      legend.tabIndex = -1;
      fieldset.append(legend);
      if (key === 'secondaires') fieldset.append(element('p','wk-hint',t('secondary_hint')));
      else if (key === 'priorite') fieldset.append(element('p','wk-hint',t('priority_hint')));
      const list = element('div','wk-options');
      choices.filter(([value]) => key !== 'secondaires' || value !== answers.priorite).forEach(([value,label]) => {
        const option = element('label','wk-option');
        const input = element('input');
        input.type = key === 'secondaires' ? 'checkbox' : 'radio';
        input.name = 'wakey-' + key;
        input.value = value;
        input.checked = Array.isArray(answers[key]) ? answers[key].includes(value) : answers[key] === value;
        input.addEventListener('change', () => {
          if (key === 'secondaires') {
            let selected = Array.isArray(answers[key]) ? [...answers[key]] : [];
            if (value === 'aucun' && input.checked) selected = ['aucun'];
            else if (input.checked) selected = [...selected.filter(item => item !== 'aucun'), value];
            else selected = selected.filter(item => item !== value);
            answers[key] = [...new Set(selected)];
            for (const checkbox of list.querySelectorAll('input')) checkbox.checked = answers[key].includes(checkbox.value);
          } else {
            answers[key] = value;
            if (key === 'priorite' && Array.isArray(answers.secondaires)) {
              answers.secondaires = answers.secondaires.filter(item => item !== value);
              if (!answers.secondaires.length) delete answers.secondaires;
            }
          }
          next.disabled = !valid();
        });
        const tick = element('span','wk-check','✓');
        tick.setAttribute('aria-hidden','true');
        option.append(input,element('span','wk-option-text',t(label)),tick);
        list.append(option);
      });
      fieldset.append(list);
      fields.append(fieldset);
      next.disabled = !valid();
      focus(legend);
    }
    function profileTitle() {
      const key = {seche:'type_dry',mixte:'type_combination',grasse:'type_oily',normale:'type_normal',inconnue:'type_unknown_result'}[diagnostic.answers.type];
      let title = t(key);
      if (diagnostic.answers.deshydratation !== 'non') title += ' · ' + t('dehydrated');
      return title;
    }
    function explanation() {
      const type = diagnostic.answers.type;
      const lines = [t('profile_' + type)];
      if (diagnostic.answers.deshydratation !== 'non') lines.push(t('profile_dehydration'));
      if (diagnostic.sensitive) lines.push(t('profile_sensitive'));
      if (diagnostic.minor) lines.push(t('profile_minor'));
      return lines.join(' ');
    }
    function why(product) {
      const strengths = diagnostic.ranking.filter(key => product.profile.weights[key] > 0);
      const category = product.profile.category;
      if (category === 'spf') return t('why_spf');
      let key = category;
      if (category === 'nettoyant') key = diagnostic.sensitive ? 'cleanser_sensitive' : 'cleanser';
      else if (category === 'creme') key = diagnostic.sensitive ? 'cream_sensitive' : diagnostic.answers.type === 'seche' ? 'cream_dry' : ['mixte','grasse'].includes(diagnostic.answers.type) ? 'cream_light' : 'cream';
      const base = t('why_' + key);
      if (['serum','huile','masque'].includes(category) && strengths.length) return base + ' ' + t('target') + ' ' + strengths.slice(0,2).map(dimension => t('need_' + dimension).toLocaleLowerCase()).join(' · ') + '.';
      return base;
    }
    function productCard(product) {
      const card = element('article','wk-product');
      const imageLink = element('a','wk-product-image');
      imageLink.href = product.url;
      imageLink.setAttribute('aria-label', product.title);
      if (product.image) {
        const img = element('img');
        img.src = product.image;
        img.alt = product.title;
        img.loading = 'lazy';
        img.width = 260;
        img.height = 260;
        imageLink.append(img);
      }
      const body = element('div','wk-product-body');
      body.append(element('span','wk-product-category',t('category_' + product.profile.category)),element('p','wk-vendor',product.vendor));
      const title = element('h3','wk-product-title');
      const link = element('a',null,product.title);
      link.href = product.url;
      title.append(link);
      body.append(title);
      if (product.variant.title && product.variant.title !== 'Default Title') body.append(element('p','wk-format',product.variant.title));
      const price = element('div','wk-price');
      price.append(element('strong',null,money(product.variant.price)));
      if (product.variant.compare_at_price > product.variant.price) price.append(element('s',null,money(product.variant.compare_at_price)));
      body.append(price,element('p','wk-why',why(product)));
      const more = element('a','wk-detail-link',t('view_product'));
      more.href = product.url;
      body.append(more);
      card.append(imageLink,body);
      return card;
    }
    function routineSteps(container, period) {
      container.replaceChildren();
      const selected = new Set(routine[mode].map(product => String(product.id)));
      for (const product of routine[period].filter(item => selected.has(String(item.id)))) {
        const li = element('li','wk-step');
        li.append(element('strong',null,t('category_' + product.profile.category)),element('span',null,product.title),element('p',null,product.profile.instruction));
        if (product.profile.frequency === 'hebdomadaire') li.append(element('span','wk-frequency',t('weekly')));
        container.append(li);
      }
    }
    function setMode(value) {
      mode = value;
      for (const button of root.querySelectorAll('[data-mode]')) {
        button.setAttribute('aria-pressed',String(button.dataset.mode === mode));
      }
      const chosen = routine[mode];
      const products = root.querySelector('[data-products]');
      products.replaceChildren(...chosen.map(productCard));
      const button = root.querySelector('[data-add]');
      button.textContent = t('add_routine') + ' — ' + money(engine.total(chosen));
      button.disabled = chosen.length === 0 || busy;
      root.querySelector('[data-routine-count]').textContent = t('product_count').replace('{count}',chosen.length);
      routineSteps(root.querySelector('[data-morning]'),'morning');
      routineSteps(root.querySelector('[data-evening]'),'evening');
    }
    function showResult() {
      diagnostic = engine.diagnose(answers);
      routine = engine.recommend(catalog,diagnostic);
      reveal(result);
      const title = root.querySelector('[data-profile-title]');
      title.textContent = profileTitle();
      root.querySelector('[data-profile-copy]').textContent = explanation();
      const needs = root.querySelector('[data-needs]');
      needs.replaceChildren();
      diagnostic.ranking.forEach((dimension,position) => {
        const card = element('div','wk-need');
        card.append(element('p','wk-eyebrow',t(['main_need','secondary_need','complement_need'][position])),element('h3',null,t('need_' + dimension)),element('p',null,t('description_' + dimension)));
        needs.append(card);
      });
      const warning = root.querySelector('[data-missing]');
      warning.hidden = routine.missing.length === 0;
      warning.textContent = routine.missing.length ? t('missing_products') + ' ' + routine.missing.map(key => t('category_' + key)).join(', ') + '.' : '';
      root.querySelector('[data-routine-note]').textContent = diagnostic.minor ? t('minor_routine') : diagnostic.sensitive ? t('sensitive_routine') : t('routine_note');
      setMode(mode);
      focus(title);
    }
    function cleanPath(value, fallback) {
      try {
        const url = new URL(value,location.origin);
        return url.origin === location.origin ? url.pathname + url.search : fallback;
      } catch { return fallback; }
    }
    async function refreshProduct(product) {
      const response = await fetch(data.root + 'products/' + encodeURIComponent(product.handle) + '.js', {headers:{Accept:'application/json'},credentials:'same-origin'});
      if (!response.ok) return null;
      const fresh = await response.json();
      const variant = fresh.variants.find(item => String(item.id) === String(product.variant.id));
      if (!fresh.available || !variant?.available) return null;
      return {...product, title:fresh.title, vendor:fresh.vendor, url:cleanPath(fresh.url,product.url), image:typeof fresh.featured_image === 'string' ? fresh.featured_image : product.image, variant:{...product.variant,price:variant.price,compare_at_price:variant.compare_at_price || 0}};
    }
    async function addRoutine() {
      if (busy) return;
      const chosen = routine[mode];
      if (!chosen.length) return;
      busy = true;
      error.textContent = '';
      const add = root.querySelector('[data-add]');
      const modeButtons = [...root.querySelectorAll('[data-mode]')];
      add.disabled = true;
      modeButtons.forEach(button => {button.disabled = true;});
      add.textContent = t('checking_stock');
      try {
        const refreshed = await Promise.all(chosen.map(refreshProduct));
        const missing = chosen.filter((product,i) => !refreshed[i]);
        const changedPrice = refreshed.some((product,i) => product && product.variant.price !== chosen[i].variant.price);
        const byId = new Map(refreshed.filter(Boolean).map(product => [String(product.id),product]));
        const missingIds = new Set(missing.map(product => String(product.id)));
        catalog = catalog.map(product => missingIds.has(String(product.id)) ? {...product,available:false} : byId.get(String(product.id)) || product);
        if (missing.length || changedPrice) {
          showResult();
          error.textContent = t(missing.length ? 'stock_changed' : 'price_changed');
          return;
        }
        const response = await fetch(data.root + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({items:engine.cartItems(refreshed)})});
        const body = await response.json();
        if (!response.ok) throw new Error(typeof body.description === 'string' ? body.description : t('cart_error'));
        location.assign(data.cart);
      } catch (issue) {
        error.textContent = issue.message || t('cart_error');
      } finally {
        busy = false;
        modeButtons.forEach(button => {button.disabled = false;});
        setMode(mode);
      }
    }
    root.querySelector('[data-start]').addEventListener('click', () => {reveal(quiz);question();});
    previous.addEventListener('click', () => {if(index > 0){index--;question();}});
    quiz.addEventListener('submit', event => {
      event.preventDefault();
      if (!valid()) return;
      if(index < definitions.length - 1){index++;question();} else showResult();
    });
    root.querySelector('[data-restart]').addEventListener('click', () => {
      for(const key of Object.keys(answers)) delete answers[key];
      index = 0;
      mode = 'essential';
      error.textContent = '';
      reveal(quiz);
      question();
    });
    root.querySelectorAll('[data-mode]').forEach(button => button.addEventListener('click', () => setMode(button.dataset.mode)));
    root.querySelector('[data-add]').addEventListener('click',addRoutine);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();
